import { createContext } from 'react';

export interface BasicFormMethodsContextInterface {
    submit?: (...args: any) => any;
    resetForm?: (...args: any) => any;
}
export const BasicFormMethodsContext = createContext<BasicFormMethodsContextInterface | null>(null);
export const BasicFormMethodsProvider = BasicFormMethodsContext.Provider;
